import React, { Component } from 'react'
import { connect } from 'react-redux'

import { translation } from '../../../../../utils/helpers'
import { hasAccess } from '../../../../../utils/auth'
import { UpdateEconomicMatch, GetOrderInvoiceLog } from '../../../../../actions/orders'
import Modal from '../../../../../shared/components/Modal'
import InvoiceLogItem from './InvoiceLogItem'
import { triggerPopup } from '../../../../../actions/backdrop'
import Baseline from './Baseline'
import MatchPrice from './MatchPrice'

import { OrderAssessmentIcons, ModalIcons } from '../../../../../shared/elements/icons'

// Elements
import Col from '../../../../../shared/elements/col'
import Divider from '../../../../../shared/elements/divider'
import Inline from '../../../../../shared/elements/inline'
import Icon from '../../../../../shared/elements/icon'

// Styles
import '../index.scss'
import './index.scss'
import { renderFullDate } from '../../../../../utils/time'

class InvoiceLog extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      show: true,
      invoiceLog: {
        OrderId: -1,
        PriceDetails: {},
        Items: []
      },
      isWP: false,
      matchGreen: false,
      matchBlue: false,
      view: 'main'
    }
    this.getInvoiceLog = this.getInvoiceLog.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
    this.renderItem = this.renderItem.bind(this)
    this.renderOrderLog = this.renderOrderLog.bind(this)
    this.hide = this.hide.bind(this)
    this.getEmptyItem = this.getEmptyItem.bind(this)
  }
  hide () {
    this.props.triggerPopup(false)
    this.setState({
      show: false
    })
  }
  getEmptyItem () {
    return {
      TotalPrice: 0,
      TotalPriceWithVat: 0,
      Price: 0,
      EnvironmentPrice: 0,
      AddonPrice: 0,
      AddonEnvironmentPrice: 0,
      PriceCorrection: 0,
      AfterEvaluation: 0
    }
  }
  componentWillReceiveProps (nextProps) {
    this.getInvoiceLog(nextProps.item.Id)
  }
  componentDidMount () {
    this.getInvoiceLog(this.props.item.Id)
    this.props.triggerPopup(true)
  }
  getInvoiceLog (orderId) {
    this.setState({
      isLoading: true,
      show: true,
      isWP: hasAccess([6], this.props.auth.user.UserType)
    }, () => {
      this.props.GetOrderInvoiceLog(orderId).then((res) => {
        if (res.data.ShopBaseline === null) {
          res.data.ShopBaseline = this.getEmptyItem()
        }
        if (res.data.WpBaseline === null) {
          res.data.WpBaseline = this.getEmptyItem()
        }
        let matchGreen = false
        let matchBlue = false
        if (this.state.isWP) {
          // Find match in items
          for (let i = 0; i < res.data.Items.length; i++) {
            const item = res.data.Items[i]
            if (item.MarkType === 1) {
              matchGreen = true
            } else if (item.MarkType === 2) {
              matchBlue = true
            }
          }

          // Find match in referredFromItems
          for (let i = 0; i < res.data.ReferredFromItems.length; i++) {
            const item = res.data.ReferredFromItems[i]
            if (item.MarkType === 1) {
              matchGreen = true
            } else if (item.MarkType === 2) {
              matchBlue = true
            }
          }
        }
        // if (orderId < 1000000) {
        //   let warningItem = {
        //     CompanyName: '',
        //     Date: null,
        //     DictionaryKey: '',
        //     GetBaselinePrice: false,
        //     InvoiceNo: null,
        //     MarkType: 0,
        //     Price: 0,
        //     ReportName: null,
        //     TextExtension: '',
        //     UserMail: '',
        //     UserName: '',
        //     UserPhone: '',
        //     VoucherFilePath: null,
        //     VoucherNo: null,
        //     IsWarning: true
        //   }
        //   res.data.Items.splice(0, 0, warningItem)
        // }
        // console.log('res.data ', res.data)
        this.setState({
          matchBlue: matchBlue,
          matchGreen: matchGreen,
          invoiceLog: res.data,
          isLoading: false
        })
      }, (err) => {
        window.toastr.err(translation('2269'))
        console.log(err)
        this.hide()
      })
    })
  }

  renderItem (val, key) {
    return (
      <div key={key}>
        <InvoiceLogItem item={val} showColor={this.state.isWP} />
        <Divider />
      </div>
    )
  }
  renderDetails () {
    return (
      <Col span={'2'}>
        <Baseline item={this.state.invoiceLog} isWP={this.state.isWP} matchGreen={this.state.matchGreen} matchBlue={this.state.matchBlue} />
      </Col>
    )
  }
  renderLogHeader () {
    const { ReferredFromCompany, ReferredFromUser, ReferredFromDate } = this.state.invoiceLog

    const onChange = (e) => {
      const { value } = e.target

      // console.log('onChange', { name, value })
      this.setState({
        view: value
      })
    }

    // console.log('logheader', { view: this.state.view, checked: this.state.view === 'main' })
    return (
      <div className='logheader'>
        <div className='logheader__btn-group'>
          <div className='logheader__tab'>
            <input id='main' name='logView' type='checkbox' className='logheader__check' value='main' onChange={onChange} checked={this.state.view === 'main'} />
            <label htmlFor='main' className='logheader__label'>Udførende</label>
          </div>
          <div className='logheader__tab'>
            <input id='refFrom' name='logView' type='checkbox' className='logheader__check' value='refFrom' onChange={onChange} checked={this.state.view === 'refFrom'} />
            <label htmlFor='refFrom' className='logheader__label'>Henvist fra</label>
          </div>
        </div>
        <div className='logheader__info'>
          <div className='logheader__info-line'>
            <span>Henvist fra:</span>
            <span>{ReferredFromCompany}</span>
          </div>
          <div className='logheader__info-line'>
            <span>Navn:</span>
            <span>{ReferredFromUser}</span>
          </div>
          <div className='logheader__info-line'>
            <span>Dato:</span>
            <span>{renderFullDate(ReferredFromDate, true)}</span>
          </div>
        </div>
      </div>
    )
  }
  renderOrderLog () {
    const { Items, ReferredFromItems } = this.state.invoiceLog

    let logTitle = translation('14839')
    let noItems = translation('14840')

    let hasItems = false
    let items = []
    switch (this.state.view) {
      case 'refFrom':
        hasItems = ReferredFromItems.length > 0
        items = ReferredFromItems
        break
      case 'main':
      default:
        hasItems = Items.length > 0
        items = Items
        break
    }

    return (
      <Col span={'2'}>
        <Inline>
          <Icon icon={OrderAssessmentIcons.Assesment_History} />
          <h3>{logTitle}</h3>
        </Inline>
        <Divider />
        {items.map(this.renderItem)}
        {!hasItems && <li>{noItems}</li>}
      </Col>
    )
  }
  render () {
    let item = this.props.item
    let orderId = item.RegNumber !== null ? item.RegNumber : ''
    if (orderId !== '' && item.Model !== '') orderId += ', '
    if (item.Model !== '') orderId += item.Model
    if (orderId === '') orderId = item.Id
    // console.log('this.state.invoiceLog.IsReferred ', this.state.invoiceLog.IsReferred)
    return (
      <div className='invoiceLogPopup'>
        <div className='poppeduplog'>
          <Modal {...this.props} show={this.state.show} onClose={this.hide} header={orderId} icon={ModalIcons.Payment_Notif} >
            {this.state.isLoading === true && (
              <div className='loading-background'>
                <div className='loading-middle'>
                  <div className='animated-background'>
                    <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                  </div>
                </div>
              </div>)}
            {this.state.isLoading === false && this.state.isWP && <MatchPrice item={this.state.invoiceLog} wpEconomicMatchType={item.WpEconomicMatchType} />}
            {this.state.isLoading === false && this.state.isWP && this.state.invoiceLog.IsReferred && this.renderLogHeader()}
            <div className='poppeduplog-large'>
              {this.state.isLoading === false && this.renderOrderLog()}
              {this.state.isLoading === false && this.renderDetails()}
            </div>
          </Modal>
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  UpdateEconomicMatch,
  GetOrderInvoiceLog,
  triggerPopup
})(InvoiceLog)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/InvoiceLog/index.js